import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsButton',
  props: {
    hasUnreadNotifications: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'NotificationsButton'
    });
    function handleClick() {
      emit('click');
    }
    return {
      __sfc: true,
      emit: emit,
      handleClick: handleClick,
      SIcon: SIcon
    };
  }
});